import React from 'react';

import styles from './DataList.scss';

interface Props {
  dataList: object[];
  columnKeys: string[];
}

const DataListView: React.FC<Props> = ({ columnKeys, dataList }) => (
  <table className={styles.dataContainer}>
    <tbody>
      {dataList.map((row, rowKey) => (
        <tr key={rowKey} className={styles.dataRow}>
          {columnKeys.map((col, colKey) => (
            <td key={colKey} className={styles.dataColumn}>
              {row[col as keyof typeof row]}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

export default DataListView;
